import { Historique } from './historique'

export class HistoriqueInfo extends Historique {
  key

  constructor(historique){
    super(historique.id, historique.idcc, historique.nom, historique.statut, historique.description, historique.datePublication)
    this.key=`${historique.idcc}_${historique.id}`
  }
}